/* DSL Stock-meter — pseudo-random "X mensen kijken nu" met seeded variation */
(function(){
  var slot = document.querySelector("[data-stock-viewers]");
  if (!slot) return;
  function seed(){ var s = 0; var u = location.pathname; for (var i=0; i<u.length; i++) s = (s*31 + u.charCodeAt(i)) & 0x7fffffff; return s; }
  var s = seed();
  function vary(){
    var n = (s % 30) + 5 + Math.floor(Math.random()*4);
    slot.textContent = n;
  }
  vary();
  setInterval(vary, 8000 + Math.random()*4000);
})();